import React, {Component} from 'react';
import "./NewsDetails.scss"
import Footer from "../../components/Footer/Footer";
import Navs from "../../components/Navs/Navs";
import ComTitle from "../../components/ComTitle/ComTitle";
import {titleObj} from "../../config/configPublic";
import {NavLink} from "react-router-dom";

class NewsDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            details: {},
            picUrl: ""
        }
    }

    componentDidMount() {
        this.getNewsDetails();
    }

    getNewsDetails() {
        this.$axios.apiList.getNewsDetails({id: this.props.match.params.id})
            .then(res => {
                this.setState({
                    details: res.data,
                    picUrl: res.data.picUrl
                })
            })
            .catch(error => {

            })
    }

    render() {
        let {details, picUrl} = this.state;
        return (
            <div className="details">
                <div className="navs">
                    <Navs fullPageIndex={6}></Navs>
                </div>
                <div className="picUrl">
                    <img src={picUrl} alt=""/>
                </div>
                <ComTitle {...titleObj.news}></ComTitle>
                <div className="content">
                    <div className="breadcrumb">
                        当前位置：<NavLink to="/home">首页</NavLink>><NavLink to="/navs">新闻中心</NavLink>>
                        <span>
                            {
                                details.type === 1 ? "公司新闻" : ""
                            }
                            {
                                details.type === 2 ? "行业资讯" : ""
                            }
                            {
                                details.type === 3 ? "物流资讯" : ""
                            }
                        </span>
                    </div>
                    <div className="title">
                        {details.title}
                    </div>
                    <div className="time">
                        发布时间：{details.createTime}
                    </div>
                    <div className="text" dangerouslySetInnerHTML={{__html: details.details}}></div>
                    {
                        details.prevTitle &&
                        <NavLink to={`/newsDetails/${details.prevId}`} className="upper">
                            上一篇 {details.prevTitle}
                        </NavLink>
                    }
                    {
                        details.nextTitle &&
                        <NavLink to={`/newsDetails/${details.nextId}`} className="lower">
                            下一篇 {details.nextTitle}
                        </NavLink>
                    }
                </div>
                <Footer></Footer>
            </div>
        );
    }
}

export default NewsDetails;
